module.exports = __webpack_public_path__ + "sprites-logo.7d805760b63105799844.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/sprites/sprites-logo.svg
// module id = 361
// module chunks = 2